import _ from 'lodash'
import vm from '../main'

const internals = {}

internals.addVehicle = function(vehicle) {
    vehicle = (({
        regNo,
        capacity,
        dateCommissioning,
        status,
        ownerName,
        ownerContact,
        billingInfo,
        camera,
        cgpsMonitoring,
        permitDetails,
        region,
        otherInfo,
        ownerDetails,
        driverName,
        _id,
        transportSupervisorName,
        transportSupervisorContact
    }) => {
        return {
            regNo,
            capacity,
            dateCommissioning,
            status,
            ownerName,
            ownerContact,
            billingInfo,
            camera,
            cgpsMonitoring,
            permitDetails,
            region,
            otherInfo,
            ownerDetails,
            driverName,
            _id,
            transportSupervisorName,
            transportSupervisorContact
        }
    })(vehicle)

    return vm.$vehicleDataRepository
        .create(vehicle)
        .then(result => {
            vehicle = result.data
            return vehicle
        })
        .catch(error => {
            console.error('vehicleService.createRegion-error:\n', error)
            throw error
        })
}

internals.updateVehicle = function(vehicle) {
    vehicle = Object.assign({}, vehicle)
    vehicle = (({
        regNo,
        capacity,
        dateCommissioning,
        status,
        ownerName,
        ownerContact,
        billingInfo,
        camera,
        cgpsMonitoring,
        permitDetails,
        region,
        otherInfo,
        ownerDetails,
        driverName,
        _id,
        transportSupervisorName,
        transportSupervisorContact
    }) => {
        return {
            regNo,
            capacity,
            dateCommissioning,
            status,
            ownerName,
            ownerContact,
            billingInfo,
            camera,
            cgpsMonitoring,
            permitDetails,
            region,
            otherInfo,
            ownerDetails,
            driverName,
            _id,
            transportSupervisorName,
            transportSupervisorContact
        }
    })(vehicle)

    return vm.$vehicleDataRepository
        .update(vehicle._id, vehicle)
        .then(result => {
            vehicle = result.data
            return vehicle
        })
        .catch(error => {
            console.error('vehicleUpdate.update-error:\n', error)
            throw error
        })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/vehicle.service.js